var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import { Status, reduceStatuses } from './Resolver';
import { SegmentType, createSegment, createPlaceholderSegment, createNotFoundSegment } from './Segments';
import { createMapping, matchMappingAgainstPathname } from './Mapping';
import { NodeMatcher, NaviNodeType } from './Node';

var SwitchMatcher =
/** @class */
function (_super) {
  __extends(SwitchMatcher, _super);

  function SwitchMatcher(options) {
    var _this = _super.call(this, options, true) || this; // Start from the beginning and take the first result, as child mounts
    // are sorted such that the first matching mount is the the most
    // precise match (and we always want to use the most precise match).


    var mappings = _this.constructor.orderedMappings;

    for (var i = mappings.length - 1; i >= 0; i--) {
      var mapping = mappings[i];
      var childEnv = matchMappingAgainstPathname(_this.env, mapping, _this.appendFinalSlash);

      if (childEnv) {
        _this.child = {
          mapping: mapping,
          matcherOptions: {
            env: childEnv,
            resolver: _this.resolver,
            withContent: _this.withContent,
            appendFinalSlash: _this.appendFinalSlash
          },
          maybeResolvableNode: mapping.maybeResolvableNode
        }; // The first match is always the only match, as we don't allow
        // for ambiguous patterns.

        break;
      }
    }

    return _this;
  }

  SwitchMatcher.prototype.execute = function () {
    var hasContent = this.withContent && this.constructor.getContent;
    var resolutionIds = [];
    var status = Status.Ready;
    var error;
    var content;

    if (this.withContent && this.constructor.getContent) {
      var contentResolution = this.resolver.resolve(this.env, this.constructor.getContent);
      resolutionIds.push(contentResolution.id);
      content = contentResolution.value;
      status = reduceStatuses(status, contentResolution.status);
      error = error || contentResolution.error;
    } else {
      content = this.constructor.content;
    }

    var title;

    if (this.constructor.getTitle) {
      var titleResolution = this.resolver.resolve(this.env, this.constructor.getTitle);
      resolutionIds.push(titleResolution.id);
      title = titleResolution.value;
      status = reduceStatuses(status, titleResolution.status);
      error = error || titleResolution.error;
    } else {
      title = this.constructor.title;
    }

    var meta;

    if (this.constructor.getMeta) {
      var metaResolution = this.resolver.resolve(this.env, this.constructor.getMeta);
      resolutionIds.push(metaResolution.id);
      meta = metaResolution.value;
      status = reduceStatuses(status, metaResolution.status);
      error = error || metaResolution.error;
    } else {
      meta = this.constructor.meta;
    }

    var childMatcher;
    var childNodeResolution;

    if (this.child) {
      var childNode = void 0;

      if (this.child.maybeResolvableNode.isNode) {
        childNode = this.child.maybeResolvableNode;
      } else {
        childNodeResolution = this.resolver.resolve(this.child.matcherOptions.env, this.child.maybeResolvableNode);
        resolutionIds.push(childNodeResolution.id);
        childNode = childNodeResolution.value;
      }

      if (!this.last || this.last.node !== childNode) {
        if (childNode) {
          childMatcher = new childNode(this.child.matcherOptions);
        }
      } else {
        childMatcher = this.last.matcher;
      }

      this.last = {
        node: childNode,
        matcher: childMatcher
      };
    }

    var childMatcherResult;

    if (childMatcher) {
      childMatcherResult = childMatcher.getResult();
    }

    var nextSegment;

    if (childMatcherResult) {
      nextSegment = childMatcherResult && childMatcherResult.segment;
    } else if (childNodeResolution) {
      nextSegment = createPlaceholderSegment(this.child.matcherOptions.env, childNodeResolution.error, this.appendFinalSlash);
    } else if (this.env.unmatchedPathnamePart) {
      nextSegment = createNotFoundSegment(this.env);
    } else {// We've matched the switch exactly, and don't need to match
      // any child segments - which is useful for creating maps.
    }

    var remainingSegments = [];

    if (nextSegment) {
      remainingSegments = nextSegment.type === SegmentType.Switch ? [nextSegment].concat(nextSegment.remainingSegments) : [nextSegment];
    } // Only create a new segment if necessary, to allow for reference-equality
    // based comparisons on segments


    return {
      resolutionIds: resolutionIds.concat(childMatcherResult ? childMatcherResult.resolutionIds : []),
      segment: createSegment(SegmentType.Switch, this.env, {
        status: status,
        error: error,
        content: content,
        meta: meta || {},
        title: title,
        switch: this.constructor,
        nextPattern: this.child && this.child.mapping.pattern,
        nextSegment: nextSegment,
        lastRemainingSegment: remainingSegments[remainingSegments.length - 1],
        remainingSegments: remainingSegments
      }, this.appendFinalSlash)
    };
  };

  SwitchMatcher.isNode = true;
  SwitchMatcher.type = NaviNodeType.Switch;
  return SwitchMatcher;
}(NodeMatcher);

export { SwitchMatcher };
export function createSwitch(options) {
  var _a;

  if (!options) {
    throw new Error("createSwitch() was supplied a function that doesn't return any value!");
  }

  if (!options.paths) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn("createSwitch() was called without a \"children\" option, but a switch without children doesn't make any sense!");
    }

    options.paths = {};
  }

  var patterns = Object.keys(options.paths); // Wildcards in PatternMap objects are null (\0) characters, so they'll
  // always be sorted to the top. As such, by sorting the patterns, the
  // most specific (i.e. without wildcard) will always be at the bottom.

  var mappings = patterns.map(function (pattern) {
    return createMapping(pattern, options.paths[pattern]);
  }).sort(function (x, y) {
    return compareStrings(x.key, y.key);
  });

  if (process.env.NODE_ENV !== 'production') {
    var paths = options.paths,
        title = options.title,
        getTitle = options.getTitle,
        meta = options.meta,
        getMeta = options.getMeta,
        content = options.content,
        getContent = options.getContent,
        other = __rest(options, ["paths", "title", "getTitle", "meta", "getMeta", "content", "getContent"]);

    var unknownKeys = Object.keys(other);

    if (unknownKeys.length) {
      console.warn("createSwitch() received unknown options " + unknownKeys.map(function (x) {
        return "\"" + x + "\"";
      }).join(', ') + ".");
    }

    if (mappings.length === 0) {
      console.warn("createSwitch() was called with an empty object {} for \"paths\". This doesn't make any sense.");
    } // Check to make sure that none of the switch supplied as patterns
    // may intefere with each other.


    var len = mappings.length;

    if (mappings.length >= 2) {
      var previousPattern = mappings[len - 1];

      for (var i = len - 2; i >= 0; i--) {
        var pattern = mappings[i]; // If previous pattern matches this one, and doesn't completely
        // replace it, and either item is a switch, then there could
        // be a conflict.
        // TODO: this warning will have false positives when a wildcard
        // is on a page and the switch is on a more specific element.

        var replacedKey = pattern.key.replace(previousPattern.regExp, '');

        if (replacedKey !== pattern.key && replacedKey.length > 0) {
          if (previousPattern.maybeResolvableNode.isNode && previousPattern.maybeResolvableNode.type === NaviNodeType.Switch || pattern.maybeResolvableNode.isNode && pattern.maybeResolvableNode.type === NaviNodeType.Switch) console.warn("createSwitch() received Switches for patterns \"" + previousPattern.pattern + "\" and \"" + pattern.pattern + "\", but this may lead to multiple switchs sharing the same URL.");
        }

        previousPattern = pattern;
      }
    } // Check for missing mountables on patterns


    for (var i = 0; i < len; i++) {
      if (!mappings[i].maybeResolvableNode) {
        var pattern = mappings[i].pattern;
        console.warn("createSwitch() received \"" + typeof mappings[i].maybeResolvableNode + "\" for pattern \"" + pattern + "\"!");
      }
    } // Check that a switch hasn't been supplied at "/", as the switch
    // could interfere with this switch.


    var indexPattern = mappings.find(function (pattern) {
      return pattern.key === '/';
    });

    if (indexPattern) {
      // Note that if we receive a split, we can't check the type, as we
      // won't know it until the split is loaded. But the same rules
      // still apply!
      if (indexPattern.maybeResolvableNode.isNode && indexPattern.maybeResolvableNode.type === NaviNodeType.Switch) {
        console.warn("createSwitch() received a Switch at the \"/\" pattern, but \"/\" must be a Page or a Redirect!");
      }
    }
  }

  return _a =
  /** @class */
  function (_super) {
    __extends(class_1, _super);

    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    return class_1;
  }(SwitchMatcher), _a.paths = options.paths, _a.meta = options.meta, _a.getMeta = options.getMeta, _a.title = options.title, _a.getTitle = options.getTitle, _a.content = options.content, _a.getContent = options.getContent, _a.orderedMappings = mappings, _a.patterns = patterns, _a;
}

function compareStrings(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}